<template>
    <tr>
        <td>
            {{ row.date }}
            <i v-if="row.deliver === 'success'"
               class="fa fa-circle"
               style="color:green;"
               :title="`Delivered at ${row.deliver_info}`"></i>
            <i v-else-if="row.deliver === 'failed'"
               class="fa fa-circle"
               style="color:#e3392b;"
               :title="`Delivery failed at ${row.deliver_info}`"></i>
            <i v-else-if="row.deliver === 'delivering'"
               class="fa fa-circle-thin"
               style="color:grey;"
               title="Delivering"></i>
            <i v-else class="fa fa-circle-thin"
               style="color:grey;"
               :title="`Not Delivered, ${row.deliver_info}`"></i>
        </td>
        <td v-if="employerColsEnabled">{{ row.employer_id }}</td>
        <td v-if="employerColsEnabled">
            <a :href="url(`admin/employer/${row.employer_id}/detail`)" target="_blank">
                {{ row.employer }}
            </a>
        </td>
        <td>
            <a :href="url(`admin/jobs/${row.job_id}`)" target="_blank">
                {{ row.job_id }}
            </a>
        </td>
        <td>
            <a :href="url(`admin/driver/${row.driver_id}`)">
                {{ row.driver_name }}
            </a>
        </td>
        <td>{{ row.app_type }}</td>
        <td>{{ row.driver_email }}</td>
        <td>{{ row.driver_phone }}</td>
        <td>{{ row.zip_code }}</td>
        <td>{{ row.state_code }}</td>
        <td>{{ row.cdl_xp }}</td>
        <td>{{ row.cdl_a_xp }}</td>
        <td>{{ row.ja_agent }}</td>
        <td>{{ row.ja_call_transfer }}</td>
        <td>{{ row.source }}</td>
        <td>
            <delivery-price-set-unset
                :employer_name="row.employer"
                :delivery_lead_id="row.id"
                :cost="row.cost"
                :is_active="row.is_active"
                @updated="toggleBudgetHidden"
            ></delivery-price-set-unset>
        </td>
    </tr>
</template>

<script>
import DeliveryPriceSetUnset from './../../../../budgets/DeliveryPriceSetUnset/vue/delivery-price-set-unset';

export default {
        components: { DeliveryPriceSetUnset },
        props: [
            'row',
            'employerColsEnabled'
        ],
        data() {
            return {
            };
        },
        methods: {
            toggleBudgetHidden(isActive) {
                this.row.is_active = isActive;
            }
        },
    };
</script>
